import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { MissionReward } from '../mission-reward.model';

@JsonObject('MissionRewardsResultsResponse')
export class MissionRewardsResultsResponse extends ApiResultsResponse<MissionReward> {

  @JsonProperty('results', [MissionReward])
  override results: MissionReward[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
